import React from 'react';
import { useIntl } from 'react-intl';

const SearchInput = (props) => {
  const intl = useIntl()
  return (
    <div className={`w-[30vw] md:w-[35vw] lg:w-[40vw] flex items-center justify-center relative`}>
      <img
        className={`absolute left-4 size-4`}
        src="/images/icons/search.svg"
        alt="Search Icon"
        style={{ objectFit: 'contain' }}
      />
      <input
        className={`py-2 text-sm focus:outline-none w-full flex px-10 justify-start cursor-pointer`}
        style={{ borderRadius: 10, border: '1px solid rgba(99,102,241,0.2)', background: 'rgba(255,255,255,0.6)', color: 'rgba(15,15,25,0.75)' }}
        onFocus={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.9)'; e.currentTarget.style.border = '1.5px solid rgba(99,102,241,0.45)'; props.onFocus?.(e); }}
        onBlur={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.6)'; e.currentTarget.style.border = '1px solid rgba(99,102,241,0.2)'; }}
        onClick={props.onClick}
        placeholder={intl.formatMessage({ id: 'DASHBOARD_SEARCH_PLACEHOLDER', defaultMessage: 'Search   Tasks  |  Projects  |  Members  |  Forms' })}
        value={props?.value}
        onChange={props?.onChange}
        onKeyDown={props?.onKeyDown}
      />
      {props?.value && <img
        className={`absolute right-4 size-2.5 cursor-pointer opacity-70`}
        onClick={() => {
          props.onChange({
            target: {
              value: ''
            }
          })
        }}
        src="/images/icons/close.svg"
        alt="Search Icon"
        style={{ objectFit: 'contain' }}
      />}
    </div>
  );
};

export default SearchInput;
